import { __awaiter } from '../../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';
import { useWindowSize } from '@websolutespa/bom-mixer-hooks';
import 'swiper/css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useLlm } from '../../../useLlm/useLlm.js';
import { useLlmView } from '../../../useLlm/useLlmView.js';
import { clamp } from '../../utils.js';

const Hints = _ref => {
  let {
    hints
  } = _ref;
  const {
    width
  } = useWindowSize();
  const theme = useLlm(state => state.theme);
  const {
    send
  } = useLlmView(state => state.actions);
  const swiperProps = {
    spaceBetween: clamp(8, 16),
    slidesOffsetAfter: clamp(20, 110),
    slidesOffsetBefore: clamp(20, 110),
    slidesPerView: clamp(1.2, 2.2)
  };
  const onClick = item => __awaiter(void 0, void 0, void 0, function* () {
    yield send(item.message || item.title, response => {
      // console.log('QuickLinks.onMessage', response.chunks);
    }, response => {
      // console.log('QuickLinks.onEnd', response);
    });
  });
  const getCard = (item, index) => {
    var _a;
    const direction = ((_a = theme.hintTitle) === null || _a === void 0 ? void 0 : _a.flexDirection) || 'row';
    return jsxs("button", {
      type: "button",
      className: "llm__hint",
      onClick: () => onClick(item),
      children: [jsxs("div", {
        className: getClassNames('llm__hint-title -llm-t-label1', direction),
        children: [item.icon && jsx("i", {
          children: jsx("img", {
            src: item.icon.src || item.icon.url,
            alt: ""
          })
        }), item.title]
      }), item.body && jsx("div", {
        className: "llm__hint-body -llm-t-body3",
        dangerouslySetInnerHTML: {
          __html: item.body
        }
      })]
    }, `card-${index}`);
  };
  return jsx("section", {
    className: "llm__hints",
    children: width < 768 ? jsx(Swiper, Object.assign({}, swiperProps, {
      children: hints.map((item, j) => jsx(SwiperSlide, {
        children: getCard(item, j)
      }, j))
    })) : hints.map(getCard)
  });
};

export { Hints };
//# sourceMappingURL=hints.js.map
